// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__etQS7","Label":"Checkbox_Label__b9hG0","InputElement":"Checkbox_InputElement__j85qq","Invalid":"Checkbox_Invalid__Y2B6D"};